import React from "react";
import "./Nav.css";
import {
    BiHome,
    BiUser,
    BiBook,
    BiBriefcaseAlt,
    BiMessageRounded,
} from "react-icons/bi";

const Nav = () => {
    return (
        <nav>
            <a href="#">
                <BiHome />
            </a>
            <a href="#about">
                <BiUser />
            </a>

            <a href="#experience">
                <BiBook />
            </a>
            <a href="#portfolio">
                <BiBriefcaseAlt />
            </a>
            <a href="#contact">
                <BiMessageRounded />
            </a>
        </nav>
    );
};

export default Nav;
